import {Button, Col, FormGroup, Input, Label, PopoverBody, Row, UncontrolledPopover} from "reactstrap";
import {RangedDatePicker} from "../../generic/fields";
import {DataTable, field} from "../../generic/tables";
import dayjs from "dayjs";
import {daysAbbr} from "../../../lib/utils/format";
import {FaInfoCircle} from "react-icons/fa";
import React from "react";
import {t} from "i18next";

const TransferDestinationTable = (props) => {
    const {selectedBase, setSelectedBase, selectedEvent, setSelectedEvent, daysFilter, setDaysFilter, bases, filtersTransfer,
        findSlotsWithSorting, calculateTotalPaidForLength, getSlotStatus, openMoveTransferModal, state} = props

    return (
        <>
            <Row>
                <Col>
                    <FormGroup>
                        <Label>
                            {t('common.forms.movePaymentModal.pickBase')}
                        </Label>
                        <Input type={'select'} name={'base_id'} value={selectedBase}
                               onChange={(e) => setSelectedBase(() => e.target.value)}>
                            {bases.map(base => <option key={base.id} value={base.id}>{base.name}</option>)}
                        </Input>
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                        <Label>
                            {t('common.forms.movePaymentModal.pickEvent')}
                        </Label>
                        <Input type={'select'} name={'event_id'} value={selectedEvent}
                               onChange={(e) => setSelectedEvent(() => e.target.value)}>
                            {bases.find(({id}) => id === +selectedBase)
                                ?.events_ids
                                ?.filter((event_id) => !event_id.name.includes('_deleted_'))
                                ?.sort((a, b) => a.name.localeCompare(b.name))
                                .map(event => <option key={event.id} value={event.id}>{event.name}</option>)}
                        </Input>
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                        <Label>
                            {t('common.forms.movePaymentModal.pickDates')}
                        </Label>
                        <RangedDatePicker daysFilter={daysFilter} setDaysFilter={setDaysFilter} wrapperClassname={'transfer__date-picker'}/>
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col>
                    <DataTable
                        findAndCount={findSlotsWithSorting}
                        filters={filtersTransfer}
                        fields={[
                            field(t('common.forms.movePaymentModal.name'), true, "name", res => <>
                                <h5>{res.name} </h5> <br/>
                                {!!res.comment && <><h6>{res.comment} </h6> <br/></>}
                                <div>{res.url}</div>
                            </>),
                            field(t('common.forms.movePaymentModal.date'), true, "start_datetime", res => <>
                                {dayjs(res.start_date).format('MM/DD ')} {daysAbbr[dayjs(res.start_date).isoWeekday()]}</>),
                            field(t('common.forms.movePaymentModal.time'), false, "time", res =>
                                res.start_time? dayjs(res.start_time, 'HH:mm:ss').format('HH:mm') + ' - ' +
                                    dayjs(res.end_time, 'HH:mm:ss').format('HH:mm'): ''),
                            field(<>
                                    {t('common.forms.movePaymentModal.reservedSits')}&nbsp;
                                    <FaInfoCircle id={"sender_email"}/>
                                    <UncontrolledPopover placement="right" target={"sender_email"} trigger={'hover'}
                                                         className="reservedSits_popover">
                                        <PopoverBody>{t('common.forms.movePaymentModal.paymentMade')}</PopoverBody>
                                    </UncontrolledPopover>
                                </>,
                                false, "booked_to_total",
                                res => <>{(res.booked_sits) + ' / ' + res.total_sits}</>
                            ),
                            field(t('common.forms.movePaymentModal.availableSits'), false, "available_sits", res => {
                                const totalPaidForLength = calculateTotalPaidForLength();
                                return <>
                                    {res.available_sits} / {totalPaidForLength} {t('common.forms.movePaymentModal.necessary')}
                                </>
                            }),
                            field(t('common.forms.movePaymentModal.pick'), false, "id", res => {
                                const slotStatus = getSlotStatus(res);
                                return (
                                    <Button
                                        color={state.id === res.id ? 'secondary' : slotStatus.color}
                                        onClick={() => openMoveTransferModal(res)}
                                        disabled={state.id === res.id || slotStatus.status === 'no_seats'}
                                    >
                                        {slotStatus.text}
                                    </Button>
                                );
                            }),
                        ]}
                        sortField="start_datetime"
                        sortDir="asc"
                        name="slots-list"
                        rowClass={res => {
                            const slotStatus = getSlotStatus(res);
                            return slotStatus.className;
                        }}
                    />
                </Col>
            </Row>
        </>
    )
}

export default TransferDestinationTable;